import { Outlet } from 'react-router';
import { ThemeProvider } from 'styled-components';

import { ErrorBoundary } from 'containers/ErrorBoundary';
import { SetFlashMessages } from 'containers/SetFlashMessages';
import { SetGMapsError } from 'containers/SetGMapsError';
import { TabContextProvider } from 'containers/TabContext';
import { TemporaryStorageContextProvider } from 'containers/TemporaryStorageContext';
import { ToastsContainer } from 'containers/ToastsContainer';
import { ThemeGlobalStyle } from 'theme/ThemeGlobalStyle';
import { themeContextValue } from 'theme/theme';

import { AppHooks } from './AppHooks';
import { ModalRoot } from './containers/Modal/ModalRoot';

export function App() {
  return (
    <ThemeProvider theme={themeContextValue}>
      <ThemeGlobalStyle />
      <AppHooks />

      <ErrorBoundary>
        <SetGMapsError />
        <SetFlashMessages />
        <TemporaryStorageContextProvider>
          <TabContextProvider>
            <ModalRoot />
            <ToastsContainer />
            <Outlet />
          </TabContextProvider>
        </TemporaryStorageContextProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
